module.exports = {"dropDownPlaceholder":"Fazer logon sem uma Adobe ID"}


//////////////////
// WEBPACK FOOTER
// ./src/components/SolutionsDropdown/__localization__/SolutionsDropdown/pt_br.json
// module id = 933
// module chunks = 0